<template>
  <scroll-layout>
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
    </template>
    <div class="fleet-match-content">
      <YkcDetailPlus class="box-card" :labelWidth="150">
        <div slot="header" class="clearfix">
          <span>【电站详情】</span>
        </div>
        <div style="display: flex; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="电站名称">
            {{ dealData(detail.stationName) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="电站编码">
            {{ dealData(detail.stationCode) }}
          </YkcDetailItemPlus>
        </div>
        <YkcDetailItemPlus label="是否参与运营活动: ">
          {{ detail.isJoinActivity }}
        </YkcDetailItemPlus>
        <YkcDetailItemPlus label="是否参与会员卡优惠: ">
          {{ detail.isJoinVip === 1 ? '是' : '否' }}
        </YkcDetailItemPlus>
      </YkcDetailPlus>
      <div style="margin: 10px 0">
        <ykc-table
          title="【价格明细】"
          :data="detail.stationVipCardInfoDTOJfpgList || []"
          :columns="peaksListColumns"></ykc-table>
      </div>
      <div style="margin: 10px 0">
        <ykc-table
          title="【分时段展示】"
          :data="detail.stationVipCardInfoDTOTimeJfpgList || []"
          :columns="priceListColumns"></ykc-table>
      </div>
      <div>
        <YkcDetailPlus class="box-card" :labelWidth="150">
          <div slot="header" class="clearfix">
            <span>【抽成费用概况】</span>
          </div>
          <YkcDetailItemPlus label="是否收取抽成:">
            {{ detail.isCommission }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="电费抽成:">
            {{ detail.powerCommission ? `${detail.powerCommission}元/度` : '——' }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="服务费抽成:">
            {{
              detail.isCommission === '是'
                ? detail.serviceCommission
                  ? detail.serviceCommission
                  : '——'
                : '——'
            }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="电站合同:">
            <div v-if="detail.attachmentName">
              <span type="files" style="margin-right: 10px; color: blue">
                {{ detail.attachmentName ? detail.attachmentName : '' }}
              </span>
              <div style="width: 30px; display: inline-block">
                <ykc-button type="text" @click="downloadContract(detail.stationVipContractInfo)">
                  下载
                </ykc-button>
              </div>
            </div>
            <div v-else>——</div>
          </YkcDetailItemPlus>
          <div style="display: flex; justify-content: space-between; width: 100%">
            <div style="width: 30%">
              <YkcDetailItemPlus label="租金:">
                {{ detail.rentAmount ? `${detail.rentAmount}元/年` : '——' }}
              </YkcDetailItemPlus>
            </div>
            <div style="width: 30%">
              <YkcDetailItemPlus label="抽成保底金额:">
                {{ detail.commissionBottomAmount ? `${detail.commissionBottomAmount}元/度` : '——' }}
              </YkcDetailItemPlus>
            </div>
            <div style="width: 30%">
              <YkcDetailItemPlus label="赞助费:">
                {{ detail.sponsorshipFee ? `${detail.sponsorshipFee}元/年` : '——' }}
              </YkcDetailItemPlus>
            </div>
          </div>

          <div style="display: flex; justify-content: space-between; width: 100%">
            <div style="width: 30%">
              <YkcDetailItemPlus label="渠道分成:">
                {{ detail.channelSharingName ? detail.channelSharingName : '——' }}
              </YkcDetailItemPlus>
            </div>
            <div style="width: 30%">
              <YkcDetailItemPlus label="电费上浮比例:">
                {{ detail.powerFeeRatio ? `${detail.powerFeeRatio}%` : '——' }}
              </YkcDetailItemPlus>
            </div>
            <div style="width: 30%">
              <YkcDetailItemPlus label="电费上浮价格:">
                {{ detail.powerFeePrice ? `${detail.powerFeePrice}元/度` : '——' }}
              </YkcDetailItemPlus>
            </div>
          </div>

          <div style="display: flex; justify-content: space-between; width: 100%">
            <div style="width: 100%">
              <YkcDetailItemPlus label="其他合同费项:" width="30%">
                {{ detail.otherContract ? detail.otherContract : '——' }}
              </YkcDetailItemPlus>
            </div>
          </div>
        </YkcDetailPlus>
        <YkcDetailPlus class="box-card" :labelWidth="150">
          <div class="clearfix" slot="header">
            <span>【兜底价信息】</span>
          </div>
          <YkcDetailItemPlus label="电站兜底服务费:">
            <div style="display: flex; justify-content: space-between; width: 100%">
              {{ detail.ensureServiceRate ? `${detail.ensureServiceRate}元/度` : '——' }}
            </div>
          </YkcDetailItemPlus>
        </YkcDetailPlus>
      </div>
      <div>
        <ykc-table
          title="价格编辑记录"
          :data="priceEditRecord"
          :columns="recordTableColumns"
          :tableConfig="recordTableConfig"
          :operateButtons="recordTableOperateButtons">
          <ykc-pagination
            align="right"
            slot="pagination"
            :total="pageInfo.total"
            :page-size.sync="pageInfo.pageSize"
            :current-page.sync="pageInfo.currentPage"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"></ykc-pagination>
        </ykc-table>
      </div>
    </div>
  </scroll-layout>
</template>

<script>
  import { chargeVipPriceFee } from '@/service/apis';

  import openDialog from './dialog';

  export default {
    components: {},
    name: 'memberCardEquityDetail',
    data() {
      return {
        showDetail: false,
        fleetTypeNew: [],
        detail: {},
        priceEditRecord: [],
        pageInfo: {
          total: 0,
          pageSize: 10,
          currentPage: 1,
        },
        pageButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        recordTableOperateButtons: [
          {
            render: (h, button, { row }) => {
              return (
                <ykc-button
                  type="text"
                  class="do-enable-btn"
                  onClick={() => {
                    this.showRecordDetail(row);
                  }}>
                  详情
                </ykc-button>
              );
            },
          },
        ],
        recordTableColumns: [
          { label: '编辑时间', prop: 'editTime' },
          { label: '编辑人', prop: 'createBy' },
          {
            label: '状态',
            prop: 'isCurrent',
          },
        ],
        recordTableConfig: {
          maxHeight: '500',
        },
        peaksListColumns: [
          {
            label: '类别名称',
            scopedSlots: {
              defaultTitle: () => '',
              default: ({ row }) => {
                const { feeType } = row;
                const feeTypeMap = {
                  1: '尖',
                  2: '峰',
                  3: '平',
                  4: '谷',
                };
                return feeTypeMap[feeType] || '——';
              },
            },
          },
          {
            label: '电费',
            scopedSlots: {
              default: ({ row: { powerRate } }) => `${powerRate}元/度`,
            },
          },
          {
            label: '服务费',
            scopedSlots: {
              default: ({ row: { serviceRate } }) => `${serviceRate}元/度`,
            },
          },
          {
            label: '平台活动服务费',
            scopedSlots: {
              default: ({ row: { activityServiceRate } }) => `${activityServiceRate || '——'}元/度`,
            },
          },
          {
            label: '会员卡服务费',
            scopedSlots: {
              default: ({ row: { vipServiceRate } }) => `${vipServiceRate || '——'}元/度`,
            },
          },
        ],
        priceListColumns: [
          {
            label: '时段',
            scopedSlots: {
              default: ({ row: { pricePeriod } }) => `${pricePeriod}`,
            },
          },
          {
            label: '电费',
            scopedSlots: {
              default: ({ row: { powerRate } }) => `${powerRate}元/度`,
            },
          },
          {
            label: '服务费',
            scopedSlots: {
              default: ({ row: { serviceRate } }) => `${serviceRate}元/度`,
            },
          },
          {
            label: '平台活动服务费',
            scopedSlots: {
              default: ({ row: { activityServiceRate } }) => `${activityServiceRate || '——'}元/度`,
            },
          },
          {
            label: '会员卡服务费',
            scopedSlots: {
              default: ({ row: { vipServiceRate } }) => `${vipServiceRate || '——'}元/度`,
            },
          },
        ],
        // priceListHeaderButtons: [
        //   {
        //     enabled: () => code('operation:price:charge:detailexport'),
        //     id: 'export',
        //     text: '导出',
        //     handleClick: this.exportData,
        //   },
        // ],
      };
    },
    created() {
      this.getDetail();
    },
    methods: {
      showRecordDetail(row) {
        openDialog(row);
      },

      /**
       * 下载合同
       */
      downloadContract(contractInfo) {
        // 直接下载文件
        if (contractInfo && contractInfo.contractAttachment) {
          const link = document.createElement('a');
          link.href = contractInfo.contractAttachment;
          link.download = contractInfo.attachmentName || 'contract.pdf';
          link.click();
        } else {
          this.$message.warning('无法下载文件');
        }
      },
      getDetail() {
        const { stationId } = this.$route.query;
        chargeVipPriceFee.detail({ id: stationId }).then(res => {
          this.detail = res;
          const contractInfo = res.stationVipContractInfo || [];
          this.detail.powerCommission = contractInfo.powerCommission;
          this.detail.serviceCommission = contractInfo.serviceCommission;
          this.detail.rentAmount = contractInfo.rentAmount;
          this.detail.sponsorshipFee = contractInfo.sponsorshipFee;
          this.detail.channelSharingType = contractInfo.channelSharingType;
          this.detail.channelSharingValue = contractInfo.channelSharingValue;
          this.detail.powerFeeRatio = contractInfo.powerFeeRatio;
          this.detail.powerFeePrice = contractInfo.powerFeePrice;
          this.detail.otherContract = contractInfo.otherContract;
          this.detail.bottomServiceFee = contractInfo.bottomServiceFee;
          this.detail.isCommission = contractInfo.isCommission;
          this.detail.contractAttachment = contractInfo.contractAttachment;
          this.detail.attachmentName = contractInfo.attachmentName;
          this.detail.isCommission = contractInfo.isCommission;
          this.detail.channelSharingName = contractInfo.channelSharingName;
          this.detail.commissionBottomAmount = contractInfo.commissionBottomAmount;
        });
        this.getPriceEditHistory();
      },

      /**
       * 获取价格编辑历史记录（带分页）
       */
      getPriceEditHistory() {
        const { stationId } = this.$route.query;
        const params = {
          stationId,
          current: this.pageInfo.currentPage,
          size: this.pageInfo.pageSize,
        };

        chargeVipPriceFee.history(params).then(res => {
          console.log('history res', res);
          this.priceEditRecord = res.records || [];
          this.pageInfo.total = res.total || 0;
        });
      },

      /**
       * 处理页码变化
       */
      handlePageChange(currentPage) {
        this.pageInfo.currentPage = currentPage;
        this.getPriceEditHistory();
      },

      /**
       * 处理页面大小变化
       */
      handleSizeChange(pageSize) {
        this.pageInfo.pageSize = pageSize;
        this.pageInfo.currentPage = 1; // 重置到第一页
        this.getPriceEditHistory();
      },
      dealData(data, append) {
        const label = append ? `${data + append}` : data;
        return label || '——';
      },
    },
  };
</script>
<style lang="scss" scoped>
  .fleet-match-content {
    display: flex;
    flex-flow: column;
    .box-card {
      .title {
        color: inherit;
      }
      .ellipsis {
        width: 500px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  table {
    width: 100%;
    border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
    th {
      height: 44px;
    }
    td {
      height: 40px;
    }
    th,
    td {
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
    }
  }
</style>
